var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 7.5,
    stroke: "#E5EAF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3499 11.6001C11.7364 11.6001 12.0495 11.9131 12.0495 12.2997V16.4996C12.0495 16.8861 11.7364 17.1998 11.3499 17.1998C10.9634 17.1998 10.6497 16.8861 10.6497 16.4996V12.2997C10.6497 11.9131 10.9634 11.6001 11.3499 11.6001Z",
    fill: "#7389C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1493 11.6001C14.5358 11.6001 14.8495 11.9131 14.8495 12.2997V16.4996C14.8495 16.8861 14.5358 17.1998 14.1493 17.1998C13.7628 17.1998 13.4498 16.8861 13.4498 16.4996V12.2997C13.4498 11.9131 13.7628 11.6001 14.1493 11.6001Z",
    fill: "#7389C3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.44989 9.50002C6.44989 9.11349 6.76357 8.7998 7.15009 8.7998H18.3493C18.7358 8.7998 19.0495 9.11349 19.0495 9.50002C19.0495 9.88655 18.7358 10.1996 18.3493 10.1996H7.15009C6.76357 10.1996 6.44989 9.88655 6.44989 9.50002Z",
    fill: "#7389C3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.84967 9.50002C7.84967 9.11349 8.16335 8.7998 8.54987 8.7998H16.9496C17.3361 8.7998 17.6498 9.11349 17.6498 9.50002V17.1997C17.6498 18.7458 16.3958 19.9999 14.8497 19.9999H10.6498C9.10374 19.9999 7.84967 18.7458 7.84967 17.1997V9.50002ZM9.25006 10.1996V17.1997C9.25006 17.9728 9.87676 18.5995 10.6498 18.5995H14.8497C15.6227 18.5995 16.2494 17.9727 16.2494 17.1997V10.1996H9.25006Z",
    fill: "#7389C3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.94954 8.09997C9.94954 6.9404 10.8899 6 12.0495 6H13.4499C14.6094 6 15.5498 6.9404 15.5498 8.09997V9.50038C15.5498 9.88691 15.2361 10.1999 14.8496 10.1999H10.6497C10.2632 10.1999 9.94952 9.88691 9.94952 9.50038L9.94954 8.09997ZM12.0495 7.40041C11.663 7.40041 11.3499 7.71344 11.3499 8.09997V8.80018H14.1494V8.09997C14.1494 7.71344 13.8364 7.40041 13.4498 7.40041H12.0495Z",
    fill: "#7389C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.7a0a55638937b217ddba148b1762afca.svg";
export { ForwardRef as ReactComponent };